<template>
  <div>
    <!-- ローディングダイアログ -->
    <DialogLoading ref="DialogLoading" :timeout-seconds="7000" />

    <!-- 認証成功 -->
    <DialogValidFramesWithQRComplete ref="DialogValidFramesWithQRComplete" />

    <!-- 認証失敗 -->
    <DialogValidFramesWithQRFails ref="DialogValidFramesWithQRFails" />

    <!-- UseInterval内のため仕様不可ダイアログ -->
    <DialogInvalidUseInterval ref="DialogInvalidUseInterval" />

    <!-- 複数利用制限のダイアログ -->
    <DialogAlreadyValidatedAnother ref="DialogAlreadyValidatedAnother" />

    <!-- 複数利用制限のダイアログ -->
    <DialogMaxConcurrentUsingOver ref="DialogMaxConcurrentUsingOver" />
  </div>
</template>

<script>
import DialogLoading from "@/views/Components/Organisms/Common/Dialog/DialogLoading";
import DialogAlreadyValidatedAnother from "@/views/Components/Organisms/MyTickets/Dialog/DialogAlreadyValidatedAnother";
import DialogMaxConcurrentUsingOver from "@/views/Components/Organisms/MyTickets/Dialog/DialogMaxConcurrentUsingOver";
import DialogValidFramesWithQRComplete from "@/views/Components/Organisms/MyTickets/Dialog/DialogValidFramesWithQRComplete";
import DialogValidFramesWithQRFails from "@/views/Components/Organisms/MyTickets/Dialog/DialogValidFramesWithQRFails";
import DialogInvalidUseInterval from "@/views/Components/Organisms/MyTickets/Dialog/DialogInvalidUseInterval";

import { onMounted, computed, watch, watchEffect, ref } from "vue";

export default {
  name: "TheSheetQRDialogs",
  props: {
    dialogAction: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const DialogLoading = ref(null);
    const DialogAlreadyValidatedAnother = ref(null);
    const DialogMaxConcurrentUsingOver = ref(null);
    const DialogValidFramesWithQRComplete = ref(null);
    const DialogValidFramesWithQRFails = ref(null);
    const DialogInvalidUseInterval = ref(null);

    const dialogRefs = {
      DialogLoading,
      DialogValidFramesWithQRComplete,
      DialogValidFramesWithQRFails,
      DialogInvalidUseInterval,
      DialogAlreadyValidatedAnother,
      DialogMaxConcurrentUsingOver,
    };

    watch(
      () => props.dialogAction,
      (dialogAction) => {
        if (!dialogAction) {
          return;
        }
        const target = dialogRefs[dialogAction.dialog];
        if (!target?.value) {
          return;
        }
        if (dialogAction.action) {
          target.value.openDialog();
        } else {
          target.value.closeDialog();
        }
      }
    );
    const pauseLoadingTimer = () => {
      if (DialogLoading.value) {
        DialogLoading.value.pauseTimer();
      }
    };

    const resumeLoadingTimer = () => {
      if (DialogLoading.value) {
        DialogLoading.value.resumeTimer();
      }
    };

    return {
      DialogLoading,
      DialogAlreadyValidatedAnother,
      DialogMaxConcurrentUsingOver,
      DialogValidFramesWithQRComplete,
      DialogValidFramesWithQRFails,
      DialogInvalidUseInterval,
      pauseLoadingTimer,
      resumeLoadingTimer,
    };
  },
};
</script>
